<template lang="pug">
//- 直播點數紀錄
.record-course-tab-four-view
  table.record-course-table
    thead
      tr
        th.row-1 交易ID
        th 交易時間
        th 班別型態
        th 課程名稱
        th.text-align-center 交易點數
    tbody
      tr(v-if="trades.length === 0")
        td.text-align-center(colspan="5") 目前無使用紀錄
      tr(v-for="(trade, index) in trades")
        td.row-1 {{ trade.tradeID }}
        td {{ trade.tradeTime }}
        td 
          span(v-if="trade.tradeState === 'C'") 扣除
          span(v-if="trade.tradeState === 'D'") 增加
        td {{ trade.tradeDescribe }}
        td.text-align-center
          span(v-if="trade.tradeState === 'C'") -
          span(v-else) +
          span {{ trade.tradeMemberPoints }}

  .list-bottom(v-if="trades.length > 0")
    nav
      ul.pagination.pagination-rounded
        li.disabled(v-if="page > 1")
          a(@click="jumpList(page, 1)", aria-label="Previous")
            i.fa.fa-chevron-left.first

        li(
          v-for="pre_page in totalPage",
          v-if="pre_page < page + 4 && pre_page > page - 4",
          :class="page == pre_page ? 'active' : ''"
        )
          a(@click="jumpList(pre_page)")
            | {{ pre_page }}

        li(v-if="page < totalPage")
          a(@click="jumpList(page, 2)", aria-label="Next")
            i.fa.fa-chevron-right.last
</template>

<script>

export default {

  data () {
    return {
      page: 1,
      totalPage: 1,
      row_total: 0,
      trades: []
    }
  },
  watch: {

  },
  created () {
    this.getStudentPointTradesLogs()
  },
  methods: {
    //- 跳頁
    async jumpList (_page = '', _opt = '') {
      if (_page) {
        this.page = (_page)
      }
      if (_opt === 1) {
        this.page = this.page - 1
      }
      if (_opt === 2) {
        this.page = this.page + 1
      }
      await this.getStudentPointTradesLogs()
      await this.goTop()
    },
    goTop () {
      this.$emit('goTop')
    },
    // 獲得學員點數交易資料
    async getStudentPointTradesLogs () {
      // 開啟載入中
      this.$root.useLoading()
      // 獲得學員點數交易紀錄
      await this.$root.apis.getStudentPointTrades(4, this.page, this.processStudentPointTradesSuccess, this.processStudentPointTradesError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理成功回傳的點數交易資料
    processStudentPointTradesSuccess (_response) {
      if (_response.body.error_code !== 0) {
        return this.processStudentPointTradesError(_response)
      }

      // 處理回傳的交易紀錄
      let trades = _response.body.data

      // 處理頁數
      this.page = _response.body.page
      this.totalPage = _response.body.preMax
      this.row_total = _response.body.total

      // 處理資料模式
      if (this.page === 1) {
        this.trades = trades
      } else {
        let vm = this
        trades.forEach(function (_trade) {
          vm.trades.push(_trade)
        })
      }
    },
    // 處理失敗回傳的點數交易資料
    processStudentPointTradesError () {

    }
  }

}
</script>
<style lang="sass" scoped>
</style>
